import React, { useMemo } from "react";
import {
	AppBar,
	Avatar,
	Badge,
	Button,
	Hidden,
	IconButton,
	InputAdornment,
	Link,
	Menu,
	MenuItem,
	OutlinedInput,
	Toolbar,
	Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
	arrowDownDefaultIcon,
	closeDefaultIcon,
	hamburgerDefaultIcon,
	notificationDefaultIcon,
	searchDefaultIcon,
	settingDefaultIcon,
	userImg,
	userDefaultIcon,
	logoutDefaultIcon,
	closeWhiteIcon,
} from "assets/images";
import "./Header.css";
import MsalAuthService from "services/msalAuth.service";
import { RootState } from "redux/store";
import { AppRoutings } from "utility/enums/app-routings";
import Emitter from "utility/emitter";
import {
	SET_ALLOCATION_HISTORY_ICON_STYLE,
	SET_SUPPLIER_DOC_HISTORY_ICON_STYLE,
} from "utility/emitterEvents";
import { UserType } from "utility/enums/user-type";
import { Shared } from "utility/shared";
import { setLoggedInUserDetail } from "redux/authStateSlice";
import { LoginUserDetail } from "models/LoginUserDetail";
import { BrandingLogo } from "components/BrandingLogo";

const Header: React.FC = () => {
	let navigate = useNavigate();
	const dispatch = useDispatch();
	const userDetails = useSelector(
		(state: RootState) => state.authState.userDetails
	);
	const toggleSidebar = () => {
		if (window.innerWidth >= 900) {
			if (document.body.classList.contains("hide-label")) {
				document.body.classList.remove("hide-label");
				Shared.hideFlyInPanel();
			} else {
				document.body.classList.add("hide-label");
			}
			Emitter.emit(SET_ALLOCATION_HISTORY_ICON_STYLE, {
				leftPadding: !document.body.classList.contains("hide-label") ? 219 : 63,
			});
			Emitter.emit(SET_SUPPLIER_DOC_HISTORY_ICON_STYLE, {
				leftPadding: !document.body.classList.contains("hide-label") ? 219 : 63,
			});
		} else {
			if (document.body.classList.contains("show-mobile-menu")) {
				document.body.classList.remove("show-mobile-menu");
			} else {
				document.body.classList.add("show-mobile-menu");
				Shared.hideFlyInPanel();
			}
			Emitter.emit(SET_ALLOCATION_HISTORY_ICON_STYLE, {
				leftPadding: 0,
				zIndex: 2,
			});
			Emitter.emit(SET_SUPPLIER_DOC_HISTORY_ICON_STYLE, {
				leftPadding: 0,
				zIndex: 2,
			});
		}
	};
	const [profileAnchorEl, setProfileAnchorEl] =
		React.useState<null | HTMLElement>(null);
	const profileMenuOpen = Boolean(profileAnchorEl);
	const profileMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setProfileAnchorEl(event.currentTarget);
	};
	const profileMenuClose = () => {
		setProfileAnchorEl(null);
	};
	const [openSearch, setOpenSearch] = React.useState(false);

	const handleLogout = async () => {
		setProfileAnchorEl(null);
		if (userDetails.userTypeId === UserType.Internal) {
			MsalAuthService.signOut();
			Shared.clearStorageValues();
		} else {
			dispatch(setLoggedInUserDetail({} as LoginUserDetail));
			navigate(AppRoutings.SignIn);
			Shared.clearStorageValues();
			localStorage.setItem(
				Shared.localStorageKeys.isExternalUserLoggedIn,
				"false"
			);
		}
	};

	const [notificationAnchorEl, setNotificationAnchorEl] =
		React.useState<null | HTMLElement>(null);
	const notificationMenuOpen = Boolean(notificationAnchorEl);
	const notificationMenuClick = (
		event: React.MouseEvent<HTMLButtonElement>
	) => {
		setNotificationAnchorEl(event.currentTarget);
	};
	const notificationMenuClose = () => {
		setNotificationAnchorEl(null);
	};

	const userName = useMemo(() => {
		return userDetails ? userDetails.fullName : "";
	}, [userDetails]);

	const redirectToSystemScheduler = (
		e:
			| React.MouseEvent<HTMLAnchorElement, MouseEvent>
			| React.MouseEvent<HTMLSpanElement, MouseEvent>
	) => {
		e.preventDefault();
		// Note: path state might needs to be changed once notification list is fetched dynamically
		const pathState = {
			showBidDetail: true,
			bidId: 1,
		};
		// navigate to system scheduler page
		navigate(AppRoutings.SystemScheduler, {
			state: pathState,
		});
		notificationMenuClose();
	};

	return (
		<AppBar position="fixed">
			<Toolbar>
				<IconButton className="hamburgerMenu" onClick={toggleSidebar}>
					<Avatar variant="square" src={hamburgerDefaultIcon} alt="Menu" />
				</IconButton>
				<Typography variant="body1" className="company-logo">
					<BrandingLogo className="logo-img" />
				</Typography>
				{/* <Hidden smDown>
					<OutlinedInput
						type="text"
						placeholder="Search"
						endAdornment={
							<InputAdornment position="end">
								<IconButton edge="end">
									<Avatar src={searchDefaultIcon} alt="Search" />
								</IconButton>
							</InputAdornment>
						}
					/>
				</Hidden>
				{openSearch && (
					<div className="search-wrapper">
						<OutlinedInput
							type="text"
							placeholder="Search"
							endAdornment={
								<InputAdornment position="end">
									<IconButton edge="end">
										<Avatar src={searchDefaultIcon} alt="Search" />
									</IconButton>
								</InputAdornment>
							}
						/>
						<IconButton
							className="search-close-btn"
							onClick={() => setOpenSearch(false)}
						>
							<Avatar src={closeDefaultIcon} alt="Close" variant="square" />
						</IconButton>
					</div>
				)}
				<Hidden smUp>
					<IconButton
						className="mobile-search-btn"
						onClick={() => setOpenSearch(true)}
					>
						<Avatar src={searchDefaultIcon} alt="Search" />
					</IconButton>
				</Hidden> */}
				{/* <IconButton
					className="notificationIcon"
					aria-controls={notificationMenuOpen ? "basic-menu" : undefined}
					aria-haspopup="false"
					aria-expanded={notificationMenuOpen ? "true" : undefined}
					onClick={notificationMenuClick}
				>
					<Badge badgeContent="03" color="primary">
						<Avatar
							variant="square"
							src={notificationDefaultIcon}
							alt="Notification"
						/>
					</Badge>
				</IconButton>
				<Menu
					className="notification-menu"
					anchorEl={notificationAnchorEl}
					open={notificationMenuOpen}
					onClose={notificationMenuClose}
					MenuListProps={{
						"aria-labelledby": "notificationMenu",
					}}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "right",
					}}
					transformOrigin={{
						vertical: "top",
						horizontal: "right",
					}}
				>
					<Typography
						variant="h4"
						className="notification-menu-heading text-center"
					>
						Notifications <span>03</span>
					</Typography>
					<MenuItem className="unread">
						<Avatar src={notificationDefaultIcon} alt="Notification 01" />
						<Link
							underline="none"
							onClick={(e) => redirectToSystemScheduler(e)}
						>
							request to establish committee meetings
						</Link>
						<IconButton
							className="notification-close-btn"
							onClick={notificationMenuClose}
						>
							<Avatar src={closeWhiteIcon} alt="Notification 01" />
						</IconButton>
					</MenuItem>
					<MenuItem onClick={notificationMenuClose} className="unread">
						<Avatar src={notificationDefaultIcon} alt="Notification 01" />
						Lorem ipsum dolor sit amet consectetur adipisicing elit.
						<IconButton className="notification-close-btn">
							<Avatar src={closeWhiteIcon} alt="Notification 01" />
						</IconButton>
					</MenuItem>
					<MenuItem onClick={notificationMenuClose} className="unread">
						<Avatar src={notificationDefaultIcon} alt="Notification 01" />
						Lorem ipsum dolor sit amet consectetur adipisicing elit.
						<IconButton className="notification-close-btn">
							<Avatar src={closeWhiteIcon} alt="Notification 01" />
						</IconButton>
					</MenuItem>
					<MenuItem onClick={notificationMenuClose}>
						<Avatar src={notificationDefaultIcon} alt="Notification 01" />
						Lorem ipsum dolor sit amet consectetur adipisicing elit.
						<IconButton className="notification-close-btn">
							<Avatar src={closeWhiteIcon} alt="Notification 01" />
						</IconButton>
					</MenuItem>
					<MenuItem onClick={notificationMenuClose}>
						<Avatar src={notificationDefaultIcon} alt="Notification 01" />
						Lorem ipsum dolor sit amet consectetur adipisicing elit.
						<IconButton className="notification-close-btn">
							<Avatar src={closeWhiteIcon} alt="Notification 01" />
						</IconButton>
					</MenuItem>
				</Menu> */}
				<Button
					id="userMenu"
					aria-controls={profileMenuOpen ? "basic-menu" : undefined}
					aria-haspopup="false"
					aria-expanded={profileMenuOpen ? "true" : undefined}
					onClick={profileMenuClick}
					className="profile-menu-btn"
				>
					<Avatar src={userImg} alt="User Img" className="user-img" />
					<Typography variant="body1">{userName}</Typography>
					<Avatar
						src={arrowDownDefaultIcon}
						alt="Down"
						className="down-arrow"
					/>
				</Button>
				<Menu
					className="profile-menu"
					anchorEl={profileAnchorEl}
					open={profileMenuOpen}
					onClose={profileMenuClose}
					MenuListProps={{
						"aria-labelledby": "userMenu",
					}}
				>
					<MenuItem
						onClick={() => {
							profileMenuClose();
							if (userDetails.userTypeId !== UserType.External) {
								navigate(AppRoutings.UserProfile);
							} else {
								navigate(AppRoutings.CompanyProfile);
							}
						}}
					>
						<Avatar src={userDefaultIcon} alt="My Profile" />
						My Profile
					</MenuItem>
					{/* <MenuItem onClick={profileMenuClose}>
						<Avatar src={settingDefaultIcon} alt="Settings" />
						Settings **
					</MenuItem> */}
					<MenuItem onClick={handleLogout} component={Link} title="Logout">
						<Avatar src={logoutDefaultIcon} alt="Logout" />
						Logout
					</MenuItem>
				</Menu>
			</Toolbar>
		</AppBar>
	);
};

export default Header;
